import { Job } from "@core/domains/jobs";
import {
  CursorPaginationSchema,
  api,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BUS_SERVICE } from "../config/index.ts";

import { NotificationSubscriptionSchema } from "./bus-notification.ts";

export const busApi = api(
  { domain: API_DOMAIN, path: `${BUS_SERVICE.LABEL}/api` },
  {
    getJobs: apiEndpoint({
      body: z.object(
        {
          ...CursorPaginationSchema.shape,
          resourceId: Job.shape.resourceId,
          type: Job.shape.type,
        },
        {
          ...CursorPaginationSchema.descriptions,
          resourceId: Job.descriptions.resourceId,
          type: Job.descriptions.type,
        },
      ),
      response: cursorPaginatedResponse(Job.schema),
    }),
    subscribeToNotifications: apiEndpoint({
      response: NotificationSubscriptionSchema,
    }),
  },
);
